/** Whether an HTTP error status should trigger access-token refresh (not logout on 403). */
export function shouldRefreshSessionOnHttpError(status: number | undefined): boolean {
  return status === 401;
}
